// Core
import React from "react"
import styled from "styled-components"

// Components
import BaseContainer from "../../../../../../components/BaseContainer"
import size from "../../../../../../styles/size"

const Section = styled.section`
  background-color: #000000;
  margin-top: 10rem;
  margin-bottom: 10rem;
  padding-top: 3rem;
  padding-bottom: 3rem;
  text-align: center;
  color: #ffffff;
  font-weight: 700;
  font-size: 4.5rem;

  @media (max-width: ${size.mobileM}) {
    font-size: 3.5rem;
  }

  @media (max-width: ${size.mobileS}) {
    font-size: 3rem;
  }
`

export default function Highlight() {
  return (
    <Section>
      <BaseContainer displayBlock>VEM SER FAMÍLIA COM A GENTE!</BaseContainer>
    </Section>
  )
}
